export const FILTER_ALL = "all";
export const FILTER_CURRENT_MONTH = "current_month";
export const FILTER_CURRENT_WEEK = "current_week";
export const FILTER_CURRENT_DAY = "current_day";
